import { useEffect, useRef, useState } from 'react'

export const useHasUserClickedOrScrolled = (): boolean => {
  const interactionRegistered = useRef(false)
  const [hasUserClickedOrScrolled, setHasUserClickedOrScrolled] = useState(false)

  useEffect(() => {
    const handleInteraction = () => {
      if (!interactionRegistered.current) {
        setHasUserClickedOrScrolled(true)
        interactionRegistered.current = true
      }
    }

    window.addEventListener('click', handleInteraction, { once: true })
    window.addEventListener('scroll', handleInteraction, { once: true })

    return () => {
      window.removeEventListener('click', handleInteraction)
      window.removeEventListener('scroll', handleInteraction)
    }
  }, [])

  return hasUserClickedOrScrolled
}
